/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React, { Component }   from 'react';
import PropTypes              from 'prop-types';
import { StyledIconLink }     from '../../atoms/StyledIconLink';
import { StyledIconLinkIcon } from '../../atoms/StyledIconLinkIcon';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export class IconLink extends Component {

    /* This method that is triggered by the onClick
     * can be removed when CSS `scroll-behavior`
     * has better support
     * https://caniuse.com/#search=scroll-behavior
     */

    smoothScrollToAnchor(target, event) {
        const element = document.querySelector(`[name=${target.replace('#','')}]`);
        if (target.indexOf('#') === 0 && element.scrollIntoView) {
            event.preventDefault();
            element.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }

    render() {
        return (
            <StyledIconLink onClick={this.smoothScrollToAnchor.bind(this, this.props.href)} name={this.props.name} margin={this.props.margin} textColour={this.props.textColour} iconColour={this.props.iconColour} href={this.props.href}>
                <StyledIconLinkIcon iconColour={this.props.iconColour}>
                    {this.props.icon}
                </StyledIconLinkIcon>
                {this.props.children}
            </StyledIconLink>
        );
    }
}

IconLink.propTypes = {
    icon: PropTypes.element,
    iconColour: PropTypes.string,
    textColour: PropTypes.string,
    margin: PropTypes.string,
    children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/molecules/IconLink/index.js